var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-2"},[_c('header',[_vm._t("header")],2),_c('v-form',[_c('label',[_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),_c('text-reader',{attrs:{"label":_vm.buttonLabel},on:{"load":_vm.readText}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }